export default function() {
  return [
    // {
      //   title: "Dashboard",
      //   to: {
        //     name: "blog-overview"
        //   },
        //   htmlBefore: '<i class="material-icons">play_arrow</i>',
        //   htmlAfter: ""
        // },
        {
          title: "Home",
          htmlBefore: '<i class="material-icons">home</i>',
          to: {
            name: "Home"
          },
          rol:"1,2,3"
        },
        {
          title: "Tareas",
          htmlBefore: '<i class="material-icons">checklist</i>',
          to: {
            name: "Tareas"
          },
          rol:"1,2,3"
        },
        {
          title: "Historial fichaje",
          htmlBefore: '<i class="material-icons">list_alt</i>',
          to: {
            name: "Historial"
          },
          rol:"1,2,3"
        },
        {
          title: "Contratos",
          htmlBefore: '<i class="material-icons">edit_note</i>',
          to: {
            name: "Contratos"
          },
          rol:"1,2,3"
        },
        {
          title: "Chat",
          htmlBefore: '<i class="material-icons">question_answer</i>',
          to: {
            name: "Chat"
          },
          rol:"1,2,3"
        },
        //     {
    //   title: "Usuarios",
    //   htmlBefore: '<i class="material-icons">play_arrow</i>',
    //   to: {
    //     name: "Users"
    //   },
    //   rol:"1"
    // },
    // {
    //   title: "Productos",
    //   htmlBefore: '<i class="material-icons">play_arrow</i>',
    //   to: {
    //     name: "Products"
    //   },
    //   rol:"1"
    // },
    // {
    //   title: "Categorías",
    //   htmlBefore: '<i class="material-icons">play_arrow</i>',
    //   to: {
    //     name: "Categories"
    //   },
    //   rol:"1"
    // },
    // {
    //   title: "Pedidos",
    //   htmlBefore: '<i class="material-icons">play_arrow</i>',
    //   to: {
    //     name: "Orders"
    //   },
    //   rol:"1,2,3"
    // },
    // {
    //   title: "Blog",
    //   htmlBefore: '<i class="material-icons">play_arrow</i>',
    //   to: {
    //     name: "blog"
    //   },
    //   rol:"1"
    // },
    // {
    //   title: "Chat",
    //   htmlBefore: '<i class="material-icons">play_arrow</i>',
    //   to: {
    //     name: "chat"
    //   },
    //   rol:"1,3"

    // }
    // {
    //   title: "Blog Posts",
    //   htmlBefore: '<i class="material-icons">vertical_split</i>',
    //   to: {
    //     name: "blog-posts"
    //   }
    // },
    // {
    //   title: "Add New Post",
    //   htmlBefore: '<i class="material-icons">note_add</i>',
    //   to: {
    //     name: "add-new-post"
    //   }
    // },
    // {
    //   title: "Forms & Components",
    //   htmlBefore: '<i class="material-icons">view_module</i>',
    //   to: {
    //     name: "components-overview"
    //   }
    // },
    // {
    //   title: "Tables",
    //   htmlBefore: '<i class="material-icons">table_chart</i>',
    //   to: {
    //     name: "tables"
    //   }
    // },
    // {
    //   title: "User Profile",
    //   htmlBefore: '<i class="material-icons">person</i>',
    //   to: {
    //     name: "user-profile-lite"
    //   }
    // },
    // {
    //   title: "Errors",
    //   htmlBefore: '<i class="material-icons">error</i>',
    //   to: {
    //     name: "errors"
    //   }
    // }
  ];
}
